import { apply, put, all, select } from 'redux-saga/effects';
import ironLegacyClient from '@app/data/ironLegacyClient';
import { isEmpty } from 'lodash';
import { getSelectedCurrency } from '@app/redux/currency/selectors';
import { getPaging } from '@app/redux/portfolios/selectors';
import { track } from '@app/analytics';
import {
  setCustomerPortfolioItems,
  setProfileLoading,
  setProfileError,
  setCustomerBuyingStats,
  setCustomerSellingStats,
  fetchCustomerPortfolioItems,
} from './actions';
import {
  getCustomerMarket,
  getCustomerMarketCountry,
} from '../customer/selectors';

export const onFetchCustomerPortfolioItems =
  function* onFetchCustomerPortfolioItems({ payload }) {
    const { type, status, search } = payload;
    try {
      const marketCountry = yield select((state) =>
        getCustomerMarketCountry(state),
      );

      yield put(setProfileLoading({ type, status }));
      const res = yield apply(
        ironLegacyClient,
        ironLegacyClient.getCustomerPortfolioItems,
        [{ country: marketCountry, ...payload }],
      );

      const { PortfolioItems: items, Pagination: paging } = res.body;
      yield put(
        setCustomerPortfolioItems({
          items,
          paging,
          type,
          status,
          search,
        }),
      );
    } catch (e) {
      // @ts-expect-error
      yield put(setProfileError({ errorText: e.message, type, status }));
    }
  };

export const onFetchCustomerBuyingStats = function* onFetchCustomerBuyingStats({
  payload: { currency },
}) {
  try {
    const res = yield apply(
      ironLegacyClient,
      ironLegacyClient.getTraderBuyingStats,
      [currency],
    );

    const [buyingStats] = res.body.data;
    yield put(setCustomerBuyingStats(buyingStats.attributes));

    // Review: Stats?
    yield put(
      track({
        event: 'buyer-identify',
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ event: string; stats: any; }' ... Remove this comment to see the full error message
        stats: buyingStats,
      }),
    );
  } catch (e) {
    // @ts-expect-error
    yield put(setProfileError(e));
  }
};

export const onFetchCustomerSellingStats =
  function* onFetchCustomerSellingStats({ payload }) {
    try {
      const selectedCurrency = yield select(getSelectedCurrency);
      const currency = payload.currency || selectedCurrency || 'USD';
      const res = yield apply(
        ironLegacyClient,
        ironLegacyClient.getTraderSellingStats,
        [currency],
      );

      const [sellingStats] = res.body.data;
      yield put(setCustomerSellingStats(sellingStats.attributes));

      // Review: Stats?
      yield put(
        track({
          event: 'seller-identify',
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ event: string; stats: any; }' ... Remove this comment to see the full error message
          stats: sellingStats,
        }),
      );
    } catch (e) {
      // @ts-expect-error
      yield put(setProfileError(e));
    }
  };

export const onfetchCustomerPortfolioItemsSet =
  function* onfetchCustomerPortfolioItemsSet({
    payload: { customerId, type, currency },
  }) {
    try {
      const paging = yield select((state) => getPaging(state, type, 'current'));
      const marketName = yield select((state) => getCustomerMarket(state));
      const isPagingEmpty = isEmpty(paging);

      yield all([
        put(
          fetchCustomerPortfolioItems({
            customerId,
            type,
            status: 'current',
            limit: 20,
            page: 1,
            sort: isPagingEmpty ? 'created_at' : paging.sort.join(','),
            order: isPagingEmpty ? 'DESC' : paging.order.join(','),
            search: '',
            currency,
            marketName,
          }),
        ),
        put(
          fetchCustomerPortfolioItems({
            customerId,
            type,
            status: 'pending',
            limit: 20,
            page: 1,
            sort: 'created_at',
            order: 'DESC',
            search: '',
            currency,
            marketName,
          }),
        ),
        put(
          fetchCustomerPortfolioItems({
            customerId,
            type,
            status: 'history',
            limit: 20,
            page: 1,
            sort: 'created_at',
            order: 'DESC',
            search: '',
            currency,
            marketName,
          }),
        ),
      ]);
    } catch (e) {
      // @ts-expect-error
      yield put(setProfileError(e));
    }
  };
